import React from 'react';

export enum CardVariant {
  Default = 'default',
  Elevated = 'elevated',
  Outlined = 'outlined',
  Flat = 'flat',
}

export enum CardPadding {
  None = 'none',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export enum CardRadius {
  None = 'none',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  Full = 'full',
}

interface CardProps {
  children: React.ReactNode;
  variant?: CardVariant;
  padding?: CardPadding;
  radius?: CardRadius;
  hoverable?: boolean;
  className?: string;
  onClick?: () => void;
}

const variantClasses = {
  default: 'bg-white border border-gray-200 shadow-sm',
  elevated: 'bg-white shadow-md',
  outlined: 'bg-white border border-gray-300',
  flat: 'bg-white',
};

const paddingClasses = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
  xl: 'p-8',
};

const radiusClasses = {
  none: '',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full',
};

export const Card: React.FC<CardProps> = ({
  children,
  variant = CardVariant.Default,
  padding = CardPadding.LG,
  radius = CardRadius.LG,
  hoverable = false,
  className = '',
  onClick,
}) => {
  const classes = [
    variantClasses[variant],
    paddingClasses[padding],
    radiusClasses[radius],
    hoverable && 'hover:shadow-md transition-shadow duration-200',
    onClick && 'cursor-pointer',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
};
